namespace advisorop.components.widgets {
    
    export class BoAccountActivitiesController{
        activities = [{
            householdName: `Test household`,
            groupName: `Super group`,
            tradeDate: new Date(2019, 7, 11, 10, 10, 10),
            settleDate: new Date(2019, 7, 12, 9, 10, 10),
            uniqueSecId: `USI`,
            securityDescription: `Test security description`,
            units: `CCV`,
            amount: 1233.34
        }, {
            householdName: `Test household`,
            groupName: `Super group`,
            tradeDate: new Date(2019, 6, 11, 10, 10, 10),
            settleDate: new Date(2019, 6, 12, 9, 10, 10),
            uniqueSecId: `USI`,
            securityDescription: `Test security description`,
            units: `CCV`,
            amount: 34350.6734
        }];
        dg: DevExpress.ui.dxDataGridOptions;

        static $inject = [`advisorService`, `generalService`]
        constructor(private advSrv: services.AdvisorService,
            private gs: services.GeneralService) {
            
            this.dg = {
                export: {
                    enabled: true,
                    fileName: `BoHouseholdAccountActivities`
                },
                bindingOptions: {
                    dataSource: `vm.activities`
                },
                //height: `350px`,
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: `Select columns`
                },
                sorting: {
                    
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: `Search...`
                },
                columns: [
                    { dataField: `householdName`, caption: `Household` },
                    { dataField: `tradeDate`, caption: `Trade Date`, sortIndex: 0, sortOrder: `desc` },
                    { dataField: `settleDate`, caption: `Settle Date` },
                    { dataField: `uniqueSecId`, caption: `Unique Sec. Id` },
                    { dataField: `securityDescription`, caption: `Security Desc.` },
                    { dataField: `units`, caption: `Units` },
                    { dataField: `amount`, caption: `Amount`, width: 110, format: { type: `fixedPoint`, precision: 2 } }                    
                ],
            };
        }

        loadActivities = () => {
            this.advSrv.getBoAccountActivities()
                    .then(response => this.activities = response.data, err => this.gs.showError(err));
        }

        $onInit() {
            // this.loadActivities();
        }

        $onChanges(evt): void {
            for (var key in evt) {
                //if (key === `householdId` && this.householdId > 0) {
                //}
            }
        }

        $routerOnActivate(next, previous) {
        }
    }



    class BoAccountActivities implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = BoAccountActivitiesController;
            this.controllerAs = `vm`;
            this.templateUrl = `spa/advisor-module/components/bo-account-activities.html`;            
        }
    }
    angular.module(Constants.APP).component(`boAccountActivities`, new BoAccountActivities());
    
}